import { useTranslation } from 'react-i18next';
import { SysNote } from '../system/SysNote';
import { SystemPage } from '../system/SystemPage';
import { usePlatformSetting } from './usePlatformSetting';

/** Розміри сторінки табличних подань (прототип v4 settings › lists); типовий — 15, як PageRequest сервера. */
const PAGE_SIZES = [10, 15, 25, 50, 100];
const DEFAULT_PAGE_SIZE = 15;

/**
 * «Загальне» (прототип v4 settings, вкладка lists): картка «Списки й таблиці» (відступи 16px 18px 18px, проміжок 14px, як у прототипі) з
 * «Типовим розміром сторінки» — налаштування платформи
 * pageSize (GET /platform/settings), вибір зберігається одразу (PUT /platform/settings/pageSize); змінює лише адміністратор платформи.
 */
export function AdminGeneralPage() {
  const { t } = useTranslation();
  const setting = usePlatformSetting('pageSize');
  const value = typeof setting.value === 'number' ? setting.value : DEFAULT_PAGE_SIZE;
  const why = setting.canEdit ? undefined : t('sysAdmin.general.onlyAdmin');
  return (
    <SystemPage title={t('sysPages.sections.general')} sub={t('sysAdmin.general.sub')}>
      {why && <SysNote>{why}</SysNote>}
      <section className="ad-lists" aria-label={t('sysAdmin.general.lists')}>
        <div className="ad-lists__head">
          <span className="sp-eyebrow">{t('sysAdmin.general.lists')}</span>
          <span className="ad-lists__desc">{t('sysAdmin.general.listsDesc')}</span>
        </div>
        <label className="ad-lists__field">
          <span className="ad-field__label">{t('sysAdmin.general.pageSize')}</span>
          <select className="sp-select ad-field__control" value={value} disabled={!setting.canEdit || setting.saving} title={why} onChange={(e) => setting.save(Number(e.target.value))}>
            {PAGE_SIZES.map((n) => <option key={n} value={n}>{t('sysAdmin.general.perPage', { count: n })}</option>)}
          </select>
        </label>
      </section>
    </SystemPage>
  );
}
